import React from 'react';
import styled from 'styled-components';
import CategoryTab from './CategoryTab';
import PostListSection from './PostListSection';
import SearchArea from './SearchArea';

const BlogMainSection = () => {
  return (
    <BlogMainSectionContainer>
      <div className="inner-container">
        {/* category tab */}
        <CategoryTab />

        {/* search area */}
        <SearchArea />

        {/* post area, load more */}
        <PostListSection />
      </div>
    </BlogMainSectionContainer>
  );
};

export default BlogMainSection;

export const BlogMainSectionContainer = styled.main`
  .inner-container {
    @media screen and (min-width: 1440px) {
      width: 100%;
      max-width: 1200px;
      margin: 192px auto;
    }
    @media screen and (min-width: 1240px) and (max-width: 1439px) {
      width: calc(100% - 192px);
      margin: 96px;
    }
    @media screen and (min-width: 905px) and (max-width: 1239px) {
      width: calc(100% - 112px);
      margin: 56px;
    }
    @media screen and (min-width: 600px) and (max-width: 904px) {
      width: calc(100% - 64px);
      margin: 32px;
    }
    @media screen and (max-width: 599px) {
      width: calc(100% - 32px);
      margin: 32px 16px;
    }
  }
`;
